// extracted by mini-css-extract-plugin
export var subtitle = "_9j-2";
export var title = "_9j-0";
export var titleNoWrap = "_9j-1";